var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.155,
    height: 33.155,
    viewBox: "0 0 33.155 33.155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "side_bar",
    transform: "translate(-2126 483)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menus",
    transform: "translate(2126 -483)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M768,73h33.155v33.155H768Z",
    transform: "translate(-768 -73)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M840.6,150.3h12.636a2.163,2.163,0,0,1,2.277,1.641,2.121,2.121,0,0,1-1.719,2.6,3.832,3.832,0,0,1-.625.045H827.971a2.186,2.186,0,0,1-2.344-1.663,2.125,2.125,0,0,1,1.708-2.579,4.207,4.207,0,0,1,.748-.045Z",
    transform: "translate(-823.995 -146.536)",
    fill: "#23262f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M840.608,346.287H827.972a2.155,2.155,0,0,1-2.277-1.641,2.121,2.121,0,0,1,1.719-2.6,3.839,3.839,0,0,1,.625-.045h25.194a2.176,2.176,0,0,1,2.322,1.585,2.12,2.12,0,0,1-1.719,2.668,4.956,4.956,0,0,1-.7.045Q846.853,346.281,840.608,346.287Z",
    transform: "translate(-824.051 -316.837)",
    fill: "#23262f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M834.033,250.447h-6.24a2.167,2.167,0,0,1-2.266-1.663,2.125,2.125,0,0,1,1.719-2.579,3.818,3.818,0,0,1,.5-.045c4.2,0,8.394-.011,12.6,0a2.139,2.139,0,0,1,.5,4.242,4.5,4.5,0,0,1-.67.045Z",
    transform: "translate(-823.906 -231.692)",
    fill: "#23262f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBar);
export default __webpack_public_path__ + "static/media/side_bar.581aaa9f878dde83221c2792b754b6be.svg";
export { ForwardRef as ReactComponent };